import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import Front from './front';  
import reportWebVitals from './reportWebVitals';
import api from './apiConnector.js';
import EmailSubscription from './front/emailSubscription';

const root = ReactDOM.createRoot(document.getElementById('root'));

if ( api.action == 'email_subscription' ) {
  root.render(
    <EmailSubscription id={api.id} type={api.type}/>
  );
} else {
  switch ( process.env.REACT_APP_SITE ) {
    case 'front':
      root.render(
        <Front/>
      );
      break;
    case 'back':
      root.render(
        <App/>
      );
      break;
  }
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
